import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const PageShownPublicLinksEventLoader: LoadableType<{
	contentId: string;
	isPage: boolean;
	isEditPage?: boolean;
}> = LoadableBackground({
	loader: async () => {
		const { PageShownPublicLinksEvent } = await import(
			/* webpackChunkName: "loadable-srcPageShownPublicLinksEvent" */ '../src/PageShownPublicLinksEvent.tsx'
		);
		return PageShownPublicLinksEvent;
	},
});
